import { useState } from "react";
import { styles } from "../../styles";
import { DAYS_SHORT, MONTHS } from "../../lib/constants";
import { parseYmd } from "../../lib/time";
import { ErrorNote } from "../common";
import { useShop } from "../../context/ShopContext";
import { useToast } from "../../context/ToastContext";
import { saveClosedDates } from "../../data/config";
import { logAudit } from "../../data/audit";

export function HolidaysCard() {
  const { closedDates } = useShop();
  const notify = useToast();
  const [newDate, setNewDate] = useState("");
  const [error, setError] = useState<string | null>(null);

  const add = async () => {
    setError(null);
    if (!newDate) return;
    if (closedDates.includes(newDate)) { setNewDate(""); return; }
    try {
      await saveClosedDates([...closedDates, newDate]);
      void logAudit(`Added holiday ${newDate}`);
      setNewDate("");
      notify("Holiday added. That day is now closed.");
    } catch {
      setError("We could not add that day. Please try again.");
    }
  };

  const remove = async (d: string) => {
    setError(null);
    try {
      await saveClosedDates(closedDates.filter((x) => x !== d));
      void logAudit(`Removed holiday ${d}`);
    } catch {
      setError("We could not remove that day. Please try again.");
    }
  };

  return (
    <div style={styles.card}>
      <h2 style={styles.cardTitle}>Closed days &amp; holidays</h2>
      <p style={styles.sub}>These dates are always blocked, even during open hours.</p>
      {error && <ErrorNote>{error}</ErrorNote>}
      <div style={styles.addRow}>
        <input
          type="date" value={newDate} onChange={(e) => setNewDate(e.target.value)}
          className="input" style={styles.dateInput} aria-label="Date to close"
        />
        <button className="primary" style={styles.primarySm} onClick={add}>Add day</button>
      </div>
      <ul style={styles.blockList}>
        {closedDates.length === 0 && <li style={styles.sub}>No closed days yet.</li>}
        {closedDates.map((d) => {
          const dd = parseYmd(d);
          return (
            <li key={d} style={styles.blockItem}>
              <span>{DAYS_SHORT[dd.getDay()]}, {MONTHS[dd.getMonth()]} {dd.getDate()}, {dd.getFullYear()}</span>
              <button className="link" style={styles.removeBtn} aria-label={`Remove ${d}`} onClick={() => remove(d)}>
                Remove
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
